import React, { FC, useRef, Suspense } from "react";
import NcImage from "components/NcImage/NcImage";
import { PostDataType } from "data/types";
import PostTypeFeaturedIcon from "components/PostTypeFeaturedIcon/PostTypeFeaturedIcon";
import useIntersectionObserver from "hooks/useIntersectionObserver";
import { Link } from "react-router-dom";
import Loader from "components/Loader";
import { ImageProps } from "types/Image";
const GallerySlider = React.lazy(() => import("components/PostFeaturedMedia/GallerySlider"));

export interface PostFeaturedMediaProps extends ImageProps {
  className?: string;
  post: PostDataType;
  isHover?: boolean;
}

// CHECK FOR VIDEO CARD ON VIEW
let PREV_RATIO = 0.0;

const PostFeaturedMedia: FC<PostFeaturedMediaProps> = ({
  className = " w-full h-full ",
  post,
  isHover = false,
  fetchPriority = "high",
  skipLazy = true,
}) => {
  const { featuredImage, postType, videoUrl, galleryImgs, audioUrl, id, href } =
    post;

  const videoRef = useRef<HTMLDivElement>(null);

  let IS_MOBILE = false;
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    IS_MOBILE = true;
  }
  const cardIntersectionObserver = useIntersectionObserver(videoRef as React.RefObject<Element>, {
    freezeOnceVisible: false,
    threshold: 0.8,
    rootMargin: "10px",
  });
  const IN_VIEW =
    (cardIntersectionObserver?.intersectionRatio || -1) > PREV_RATIO;
  PREV_RATIO = cardIntersectionObserver?.intersectionRatio || 0;

  const isPostMedia = () => postType === "video" || postType === "audio";

  const renderGallerySlider = () => {
    if (!galleryImgs) return null;
    return (
      <Suspense fallback = { <Loader />}>
      <GallerySlider
        href={href}
        galleryImgs={galleryImgs}
        uniqueClass={`PostFeaturedGallery_${id}`}
      />
      </Suspense>
    );
  };

  const renderContent = () => {
    // GALLERY
    if (postType === "gallery") {
      return renderGallerySlider();
    }

    // ICON
    return (
      <Link to={href} aria-label="post details page" className="block absolute inset-0">
        {isPostMedia() && (
          <span className="absolute inset-0 flex items-center justify-center ">
            <PostTypeFeaturedIcon
              className="hover:scale-105 transform cursor-pointer transition-transform"
              postType={postType}
            />
          </span>
        )}
      </Link>
    );
  };

  return (
    <div
      className={`nc-PostFeaturedMedia relative ${className}`}
      data-nc-id="PostFeaturedMedia"
      ref={videoRef}
    >
     <NcImage containerClassName="absolute inset-0 flex items-center justify-center w-full h-full" decoding="async" fetchPriority={fetchPriority} skipLazy={skipLazy} loading={skipLazy ? "eager" : "lazy"} className="w-full h-auto object-contain" src={featuredImage} />
      {renderContent()}
    </div>
  );
};

export default PostFeaturedMedia;
